import axiosWatcher from '@/utils/axios-watcher'
import { default as VuxResource, flatMenuConfig, transMenuAliasToUri, access } from 'ivux-resource/src/index'
import Main from '_c/main'

export default function(Vue, options = {}) {
	var { router, store, i18n, config } = options

	// 获取resTree
	router.beforeEach((to, from, next) => {
		if (store.state.user.hasGetUserInfo && !store.state.resource.hasMenu) {
			store.dispatch('getResAccess').then(() => next())
		} else {
			next()
		}
	})

	// install ivux-resource
	VuxResource(Vue, {
		router,
		store,
		i18n,
		// 设置动态主页
		homeName: config.homeName,
		// 菜单配置
		menuConfig: config.menuConfig,
		// 模块别名设置
		moduleAlias: transMenuAliasToUri(flatMenuConfig(config.menuConfig)),
		// 容器组件
		resolveMain: Main,
	})

	// 登录失效，清理res
	axiosWatcher.$on("sessionLost", () => {
		store.commit('resource/clearRes')
	})
	
	// 退出，清理res
	store.subscribe((mutation, state) => {
		// 记忆用户tab浏览记录
		if (mutation.type == "clearUser") {
			store.commit('resource/clearRes')
		}
	})
}
